import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Divider,
    TextField,
    InputAdornment,
    // Chip,
    FormControlLabel,
    Stack,
    // Tooltip,
    Checkbox,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Helper from '../../utility/helper';
import { makeStyles } from '@mui/styles';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 18,
    },
}));

const PublishEventList = (props) => {
    const columnsData = useState(null);
    const classes = useStyles();
    const rowsData = useState(null);
    const disableButton = useState(false);
    const [search, setSearch] = React.useState('');
    const [pub, setPub] = React.useState(false);
    const [unPub, setUnPub] = React.useState(false);
    const filterRowsData = useState(null);
    const [loading, setLoading] = React.useState(false);
    const [runTimeIds, setRunTimeIds] = React.useState([]);
    useEffect(() => {
        if (props.data && columnsData.get() == null && rowsData.get() == null) {
            const { columns, rows } = props.data;
            if (columns.length > 0 && rows.length > 0) {
                rowsData.set(JSON.parse(JSON.stringify(rows)));
                filterRowsData.set(JSON.parse(JSON.stringify(rows)));
                columnsData.set(JSON.parse(JSON.stringify(columns)));
            }
            // console.log(' props.data.rows', props.data.rows);

            let newColumnsData = [...columnsData.attach(Downgraded).get()];
            let filterData = props.data.rows.filter(
                (item) => item.participant.published !== true || item.participant.schedulePublished !== true
            );
            let efilterData = props.data.rows.filter(
                (item) => item.participant.published !== false || item.participant.schedulePublished !== false
            );
            
            if (filterData.length === 0) {
                let updates = {
                    permission: 2,
                };
                newColumnsData[3] = {
                    ...newColumnsData[3],
                    ...updates,
                };
            }
            if (efilterData.length === 0) {
                let updates = {
                    permission: 0,
                };
                newColumnsData[3] = {
                    ...newColumnsData[3],
                    ...updates,
                };
            }

            columnsData.set(newColumnsData);
        }
    }, [props]);

    const handleSearchChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            let modifyList = [];
            let newFilterRowsData = [
                ...filterRowsData.attach(Downgraded).get(),
            ];
            newFilterRowsData.map((row) => {
                let keys = Object.keys(row);
                keys.map((key) => {
                    if (
                        key == 'participant' ||
                        key == 'role' ||
                        key == 'tags'
                    ) {
                        if (
                            typeof row[key].label === 'string' &&
                            row[key].label
                                .toLowerCase()
                                .indexOf(value.toLowerCase()) > -1
                        ) {
                            if (modifyList.indexOf(row) == -1)
                                modifyList.push(row);
                        }
                    }
                });
            });
            filterRowsData.set(modifyList);
        } else {
            handleCancel();
        }
    };

    const setUserHeadPermission = (colIndex, column, permission) => {
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let newColumnsData = [...columnsData.attach(Downgraded).get()];
        newColumnsData[colIndex].permission = permission;
        newRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == column.id) {
                    setRunTimeIds(runTimeIds => [...runTimeIds,row.participant.userID] );
                    row[key].permission = permission;
                    row.participant[key] = permission === 2 ? true : false;
                }
            });
        });
        columnsData.set(newColumnsData);
        filterRowsData.set(newRowsData);
    };

    const setAllHeaderPermission = (columns, rows) => {
        columns.map((column) => {
            if (
                column.id != 'participant' &&
                column.id != 'role' &&
                column.id != 'tags'
            ) {
                let totalRows = 0;
                let perm0 = 0;
                let perm1 = 0;
                let perm2 = 0;
                rows.forEach((row) => {
                    let keys = Object.keys(row);
                    keys.forEach((key) => {
                        if (key == column.id) {
                            if (row[key]['permission'] == 0) perm0++;
                            else if (row[key]['permission'] == 1) perm1++;
                            else if (row[key]['permission'] == 2) perm2++;
                            totalRows++;
                        }
                    });
                });
                if (totalRows > 0 && totalRows == perm0) {
                    column.permission = 0;
                } else if (totalRows > 0 && totalRows == perm1) {
                    column.permission = 1;
                } else if (totalRows > 0 && totalRows == perm2) {
                    column.permission = 2;
                } else {
                    column.permission = null;
                }
            }
        });
        return columns;
    };
    const setColumnHeaderPermission = (column, colIndex) => {
        column.permission = null;
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let totalRows = 0;
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        newRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == column.id) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    totalRows++;
                }
            });
        });
        if (totalRows > 0 && totalRows == perm0) {
            column.permission = 0;
        } else if (totalRows > 0 && totalRows == perm1) {
            column.permission = 1;
        }
        if (totalRows > 0 && totalRows == perm2) {
            column.permission = 2;
        }

        columnsData[colIndex].set(column);
        setTimeout(() => {
            let newRowsData = [...filterRowsData.attach(Downgraded).get()];
            let newColumnsData = [...columnsData.attach(Downgraded).get()];
            let newColumns = setAllHeaderPermission(
                newColumnsData,
                newRowsData
            );
            columnsData.set(newColumns);
        }, 100);
    };

    const setUserPermission = (rowIndex, colIndex, column, permission) => {
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let row = newRowsData[rowIndex];
        let keys = Object.keys(row);
        keys.map((key) => {
            // console.log(key, row);
            // console.log(permission);
            // console.log(column);

            if (key == column.id) { 
                setRunTimeIds(runTimeIds => [...runTimeIds,row.participant.userID] );
                row[key].permission = permission;
                row.participant[key] = permission === 2 ? true : false;
            }
        });
        filterRowsData[rowIndex].set(JSON.parse(JSON.stringify(row)));
        setColumnHeaderPermission(column, colIndex);
    };
    // console.log("runTimeIds",runTimeIds);
    const handleClick = (e) => {
        let obj = {};
        let publishedArray = [];
        let selectedUsers = [];
        let selectedScheduleUsers = [];
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        e.preventDefault();
        if (filterRowsData.get() && filterRowsData.get().length > 0) {
            filterRowsData.get().map((row) => {
                let newObj = {};
                newObj = {
                    userID: row.participant.userID,
                    connectionID: row.participant.userID,
                    isPublished: row.participant.published,
                    isSchedulePublished: row.participant.schedulePublished,
                };
                publishedArray.push(newObj);
            });
        }
        let uniqueArr = [...new Set(runTimeIds)];
        let newPublishedArr = []; 
        publishedArray &&
            publishedArray.map((user) => {
                uniqueArr.map((id) => {
                    if(user.userID === id){
                        newPublishedArr.push(user)  
                    }
                }) 
            });
            newPublishedArr &&
            newPublishedArr.map((user) => {
                if (user.isPublished === true) {
                    selectedUsers.push(user.userID);
                }
                if (user.isSchedulePublished === true) {
                    selectedScheduleUsers.push(user.userID);
                }
            })
            
            // console.log("newPublishedArr",newPublishedArr, selectedUsers, selectedScheduleUsers);
        obj = {
            eventID: eventInfo.eventID,
            modifiedBy: userInfo.userID,
            UserWiseEventPublishSetting: newPublishedArr,
            IsBulk: true,
            Ids: selectedUsers.join(','),
            scheduleIds: selectedScheduleUsers.join(','),
        };
        // console.log(obj);

        if (obj && obj !== {}) {
            disableButton.set(true);
            setLoading(true)
            ApiHelper.post(APIURLConstants.PARTICIPANT_EVENT_PUBLISHED, obj)
                .then((res) => {
                    if (res.data) {
                        setLoading(false)
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Event published successfully',
                        });
                        setSearch('');
                        rowsData.set(null);
                        columnsData.set(null);
                        filterRowsData.set(null);
                        props.getAllData();
                        disableButton.set(false);
                    }
                    disableButton.set(false);
                })
                .catch((err) => {
                    if (err) {
                        setLoading(false)
                        console.log('err : ', err);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error in event published',
                        });
                        disableButton.set(false);
                    }
                });
                ParticipantEventPublishedEmail(obj);
        }
    };

    const ParticipantEventPublishedEmail = (obj) =>{
        ApiHelper.post(APIURLConstants.PARTICIPANT_EVENT_PUBLISHED_EMAIL, obj)
                .then((res) => {

                })
    }

    const handleCancel = () => {
        const { columns, rows } = props.data;
        if (columns.length > 0 && rows.length > 0) {
            columnsData.set(JSON.parse(JSON.stringify(columns)));
            rowsData.set(JSON.parse(JSON.stringify(rows)));
            filterRowsData.set(JSON.parse(JSON.stringify(rows)));
        }
    };
    const handleReset = () => {
        const { columns, rows } = props.data;
        if (columns.length > 0 && rows.length > 0) {
            columnsData.set(JSON.parse(JSON.stringify(columns)));
            rowsData.set(JSON.parse(JSON.stringify(rows)));
            filterRowsData.set(JSON.parse(JSON.stringify(rows)));
        }
        setPub(false);
        setUnPub(false);
    };
    const handlePublished = (event) => {
        setPub(event);
        // handlePubUnPub('publish');
        if (event === true && unPub === true) {
            handleCancel();
            return;
        }
        if (event === false && unPub === false) {
            handleCancel();
            return;
        }

        let modifyList = [];
        let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
        // console.log(newFilterRowsData);
        newFilterRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == 'participant') {
                    if (row[key].published === event) {
                        if (modifyList.indexOf(row) == -1) modifyList.push(row);
                    }
                    // if (row[key].schedulePublished === event) {
                    //     if (modifyList.indexOf(row) == -1) modifyList.push(row);
                    // }
                }
            });
        });
        filterRowsData.set(modifyList);
    };
    const handleUnPublished = (event) => {
        setUnPub(event);
        if (event === true && pub === true) {
            handleCancel();
            return;
        }
        if (event === false && pub === false) {
            handleCancel();
            return;
        }

        let modifyList = [];
        let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
        // console.log(newFilterRowsData);
        newFilterRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == 'participant') {
                    if (row[key].published === !event) {
                        if (modifyList.indexOf(row) == -1) modifyList.push(row);
                    }
                    // if (row[key].schedulePublished === !event) {
                    //     if (modifyList.indexOf(row) == -1) modifyList.push(row);
                    // }
                }
            });
        });
        filterRowsData.set(modifyList);

        // handlePubUnPub('unpublish');
    };
    // const handlePubUnPub = (key) => {
    //     console.log(key);
    //     let modifyList = [];
    //     let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
    //     console.log(newFilterRowsData);
    //     newFilterRowsData.map((row) => {
    //         let keys = Object.keys(row);
    //         keys.map((key) => {
    //             if (key == 'participant') {
    //                 if (row[key].published === true) {
    //                     if (modifyList.indexOf(row) == -1) modifyList.push(row);
    //                 }
    //             }
    //         });
    //     });
    //     filterRowsData.set(modifyList);
    // };

    return (
        <>
            {columnsData.get() && filterRowsData.get() ? (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            minHeight: '56px',
                            mb: 1.5,
                            justifyContent:'space-between'
                        }}>
                        <Box>
                        <TextField
                            id="search"
                            size="small"
                            label={'Search'}
                            value={search}
                            onChange={handleSearchChange}
                            autoComplete="off"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                // m: 1,
                                maxWidth: { xs: '180px', md: '90%' },
                            }}
                        />
                        <FormControlLabel
                            label="Event Published"
                            control={
                                <Checkbox
                                    inputProps={{
                                        'aria-label': 'published',
                                    }}
                                    checked={pub}
                                    onChange={(event) =>
                                        handlePublished(event.target.checked)
                                    }
                                    // color="secondary"
                                    disabled={false}
                                    sx={{ marginLeft: 2 }}
                                />
                            }
                        />
                        <FormControlLabel
                            label="Event UnPublished"
                            control={
                                <Checkbox
                                    inputProps={{
                                        'aria-label': 'unPublished',
                                    }}
                                    checked={unPub}
                                    onChange={(event) =>
                                        handleUnPublished(event.target.checked)
                                    }
                                    // color="secondary"
                                    disabled={false}
                                    sx={{ marginLeft: 2 }}
                                />
                            }
                        />
                        </Box>
                         <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                                item>
                                <ButtonContainer
                                    handleClick={handleClick}
                                    handleCancel={handleReset}
                                    buttonText={'Save'}
                                    cancelText={'Reset'}
                                    disableButton={disableButton.get()}
                                    loading={loading}
                                    showLoading={loading}
                                />
                            </Box>
                    </Box>
                    <Box
                        component="form"
                        sx={{
                            // p: 2,
                            width: '100%',
                        }}
                        autoComplete="off"
                        onSubmit={handleClick}>
                        <TableContainer component={Paper}  sx={{overflow:'auto',maxHeight: '100vh'}}>
                            <Table>
                                <TableHead>
                                    <TableRow size="small" style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5'}} >
                                        {columnsData
                                            .attach(Downgraded)
                                            .get()
                                            .map((column, index) => (
                                                <StyledTableCell
                                                    key={`column_${index}`}
                                                    align={column.align}
                                                    size="small">
                                                    <Box
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems={
                                                            column.align ==
                                                            'left'
                                                                ? 'flex-start'
                                                                : 'center'
                                                        }>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            sx={{
                                                                marginLeft:
                                                                    column.label ===
                                                                    'Published'
                                                                        ? '1%'
                                                                        : '',
                                                            }}
                                                            color="primary">
                                                            {column.label ===
                                                            'Tags'
                                                                ? null
                                                                : column.label}
                                                        </Typography>
                                                        {column.showPermission ? (
                                                            <Box
                                                                sx={{
                                                                    alignItems:
                                                                        'right',
                                                                    display:
                                                                        'flex',
                                                                }}>
                                                                <Stack
                                                                    spacing={1}
                                                                    direction="row">
                                                                    {/* <Tooltip
                                                                        title={
                                                                            'Disable'
                                                                        }
                                                                        aria-label={
                                                                            'Disable'
                                                                        }> */}
                                                                        <RemoveCircleRoundedIcon
                                                                            className={
                                                                                classes.fontSize
                                                                            }
                                                                            sx={{
                                                                                color:
                                                                                    column.permission ===
                                                                                    0
                                                                                        ? theme
                                                                                              .palette
                                                                                              .error
                                                                                              .main
                                                                                        : theme
                                                                                              .palette
                                                                                              .grey[500],
                                                                            }}
                                                                            onClick={() =>
                                                                                setUserHeadPermission(
                                                                                    index,
                                                                                    column,
                                                                                    0
                                                                                )
                                                                            }
                                                                        />
                                                                    {/* </Tooltip>
                                                                    <Tooltip
                                                                        title={
                                                                            'Enable'
                                                                        }
                                                                        aria-label={
                                                                            'Enable'
                                                                        }> */}
                                                                        <CheckCircleRoundedIcon
                                                                            className={
                                                                                classes.fontSize
                                                                            }
                                                                            sx={{
                                                                                color:
                                                                                    column.permission ===
                                                                                    2
                                                                                        ? theme
                                                                                              .palette
                                                                                              .success
                                                                                              .main
                                                                                        : theme
                                                                                              .palette
                                                                                              .grey[500],
                                                                            }}
                                                                            onClick={() =>
                                                                                setUserHeadPermission(
                                                                                    index,
                                                                                    column,
                                                                                    2
                                                                                )
                                                                            }
                                                                        />
                                                                    {/* </Tooltip> */}
                                                                </Stack>
                                                            </Box>
                                                        ) : null}
                                                    </Box>
                                                </StyledTableCell>
                                            ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filterRowsData.get()
                                        ? filterRowsData
                                              .attach(Downgraded)
                                              .get()
                                              .map((row, rowIndex) => {
                                                  return (
                                                      <StyledTableRow
                                                          key={`row_${rowIndex}`}
                                                          hover
                                                          tabIndex={-1}>
                                                          {columnsData
                                                              .attach(
                                                                  Downgraded
                                                              )
                                                              .get()
                                                              .map(
                                                                  (
                                                                      column,
                                                                      colIndex
                                                                  ) => {
                                                                      const value =
                                                                          row[
                                                                              column
                                                                                  .id
                                                                          ];
                                                                      return (
                                                                          <TableCell
                                                                              key={`row_column_${colIndex}`}
                                                                              align={
                                                                                  value &&
                                                                                  value.align
                                                                              }
                                                                              size="small">
                                                                              <Box
                                                                                  display="flex"
                                                                                  flexDirection={
                                                                                      'row'
                                                                                  }
                                                                                  alignItems={
                                                                                      column.align ==
                                                                                      'left'
                                                                                          ? 'flex-start'
                                                                                          : 'center'
                                                                                  }>
                                                                                  {value.showLabel ? (
                                                                                      <Typography
                                                                                          variant="h4"
                                                                                          flexGrow={
                                                                                              1
                                                                                          }
                                                                                          fontSize={
                                                                                              14
                                                                                          }
                                                                                          fontWeight={
                                                                                              400
                                                                                          }>
                                                                                          {column.id ===
                                                                                          'participant' ? (
                                                                                              value.label.search(
                                                                                                  'DELETED'
                                                                                              ) !==
                                                                                              -1 ? (
                                                                                                  <>
                                                                                                      <span
                                                                                                          style={{
                                                                                                              color: 'red',
                                                                                                          }}>{`DELETED`}</span>{' '}
                                                                                                      <span>
                                                                                                          {value.label.replace(
                                                                                                              'DELETED',
                                                                                                              ''
                                                                                                          )}
                                                                                                      </span>
                                                                                                  </>
                                                                                              ) : (
                                                                                                  value.label.replace(
                                                                                                      'DELETED',
                                                                                                      ''
                                                                                                  )
                                                                                              )
                                                                                          ) : (
                                                                                              value.label
                                                                                          )}
                                                                                      </Typography>
                                                                                  ) : null}
                                                                                  {value.showPermission ? (
                                                                                      <Box
                                                                                          sx={{
                                                                                              alignItems:
                                                                                                  'center',
                                                                                              display:
                                                                                                  'flex',
                                                                                          }}>
                                                                                          <Stack
                                                                                              spacing={
                                                                                                  1
                                                                                              }
                                                                                              direction="row">
                                                                                              {/* <Tooltip
                                                                                                  title={
                                                                                                      'Disable'
                                                                                                  }
                                                                                                  aria-label={
                                                                                                      'Disable'
                                                                                                  }> */}
                                                                                                  <RemoveCircleRoundedIcon
                                                                                                      className={
                                                                                                          classes.fontSize
                                                                                                      }
                                                                                                      sx={{
                                                                                                          color:
                                                                                                              value.permission ==
                                                                                                              0
                                                                                                                  ? theme
                                                                                                                        .palette
                                                                                                                        .error
                                                                                                                        .main
                                                                                                                  : theme
                                                                                                                        .palette
                                                                                                                        .grey[500],
                                                                                                      }}
                                                                                                      onClick={() =>
                                                                                                          setUserPermission(
                                                                                                              rowIndex,
                                                                                                              colIndex,
                                                                                                              column,
                                                                                                              0
                                                                                                          )
                                                                                                      }
                                                                                                  />
                                                                                              {/* </Tooltip>
                                                                                              <Tooltip
                                                                                                  title={
                                                                                                      'Enable'
                                                                                                  }
                                                                                                  aria-label={
                                                                                                      'Enable'
                                                                                                  }> */}
                                                                                                  <CheckCircleRoundedIcon
                                                                                                      className={
                                                                                                          classes.fontSize
                                                                                                      }
                                                                                                      sx={{
                                                                                                          color:
                                                                                                              value.permission ==
                                                                                                              2
                                                                                                                  ? theme
                                                                                                                        .palette
                                                                                                                        .success
                                                                                                                        .main
                                                                                                                  : theme
                                                                                                                        .palette
                                                                                                                        .grey[500],
                                                                                                      }}
                                                                                                      onClick={() =>
                                                                                                          setUserPermission(
                                                                                                              rowIndex,
                                                                                                              colIndex,
                                                                                                              column,
                                                                                                              2
                                                                                                          )
                                                                                                      }
                                                                                                  />
                                                                                              {/* </Tooltip> */}
                                                                                          </Stack>
                                                                                      </Box>
                                                                                  ) : null}
                                                                              </Box>
                                                                          </TableCell>
                                                                      );
                                                                  }
                                                              )}
                                                      </StyledTableRow>
                                                  );
                                              })
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </>
            ) : null}
        </>
        // </Paper>
    );
};
export default PublishEventList;
